/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateKalendereintragDto } from '../../models/create-kalendereintrag-dto';
import { KalendereintragDto } from '../../models/kalendereintrag-dto';

export interface CreateKalendereintragForMitarbeiter$Plain$Params {

/**
 * ID des Mitarbeiters
 */
  mitarbeiterId: string;
  
    /**
     * Daten für den Kalendereintrag
     */
    body?: CreateKalendereintragDto
}

export function createKalendereintragForMitarbeiter$Plain(http: HttpClient, rootUrl: string, params: CreateKalendereintragForMitarbeiter$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<KalendereintragDto>> {
  const rb = new RequestBuilder(rootUrl, createKalendereintragForMitarbeiter$Plain.PATH, 'post');
  if (params) {
    rb.path('mitarbeiterId', params.mitarbeiterId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<KalendereintragDto>;
    })
  );
}

createKalendereintragForMitarbeiter$Plain.PATH = '/v1/mitarbeiter{mitarbeiterId}/kalendereintraege';
